import { UserMultiValueContentLinked } from '../../../../../User'

function RecipientContent({ children, ...restProps }) {
  return (
    <>
      <UserMultiValueContentLinked {...restProps} />
      {children}
    </>
  )
}

export default RecipientContent
